const json = `
<p>版本生效日期：2026年7月9日</p>
<p>版本更新日期：2026年7月9日</p>
<p>歡迎您使用 DV Link。DV Link 由廣州錢櫃物聯科技有限公司（以下簡稱「我們」）提供。請您在使用本應用程式前仔細閱讀並充分理解本《DV Link 使用者協議》（以下簡稱「本協議」），尤其是與服務範圍、使用者責任、風險提示、責任限制、協議變更、爭議解決相關的條款。</p>
<p>如您不同意本協議的全部或部分內容，請停止使用本應用程式。您下載、安裝、開啟、使用本應用程式，或點擊同意本協議，即表示您已閱讀、理解並同意接受本協議約束。</p>
<p class="subTitle">一、協議範圍</p>
<p>1. 本協議適用於 DV Link iOS / iPadOS 應用程式及其相關功能。</p>
<p>2. 本協議與《DV Link 隱私權政策》共同構成您使用本應用程式的基本規則。涉及個人資料處理、系統權限、資料儲存和使用者權利的內容，請同時閱讀《DV Link 隱私權政策》。</p>
<p>3. 如本應用程式後續新增付費服務、帳號服務、雲端同步、線上客服、第三方 SDK 或其他新功能，我們可能會發布補充協議、專項規則或更新後的協議。補充協議、專項規則經依法公示或向您提示後，與本協議具有同等效力。</p>
<p class="subTitle">二、服務內容</p>
<p>1. DV Link 是一款用於 USB 直錄裝置錄影匯入與本機播放的工具類應用程式。</p>
<p>2. 本應用程式目前核心流程為：您連接 USB 直錄裝置後，透過 iOS 系統檔案選擇器選擇裝置資料夾或錄影資料夾；本應用程式在您授權的範圍內掃描可識別的錄影檔案；您可以將選定錄影下載到 iPhone 或 iPad 本機，並進行本機播放、管理、分享或匯出。</p>
<p>3. 本應用程式目前版本不提供帳號註冊、登入功能，不提供雲端同步、雲端備份、遠端裝置控制、韌體升級、即時預覽或裝置私有協議通訊功能。</p>
<p>4. 本應用程式不自動監聽 USB 插入事件，不繞過 iOS 系統檔案選擇器靜默讀取外部儲存根目錄，不承諾插入裝置後自動連接或自動識別全部 USB 裝置。</p>
<p>5. 本應用程式是否能夠識別或讀取外接裝置，可能受到 iOS / iPadOS 系統版本、裝置型號、轉接頭、供電狀態、USB 裝置檔案系統、檔案目錄結構、檔案格式、使用者授權狀態等因素影響。</p>
<p class="subTitle">三、使用條件</p>
<p>1. 您應當具備與使用本應用程式相適應的民事行為能力。若您是不滿十四周歲的兒童或其他限制民事行為能力人，請在父母或其他監護人的同意和指導下使用本應用程式。</p>
<p>2. 您使用本應用程式處理的錄影、圖片、檔案或其他內容，應當來源合法，並且您應當對相關內容享有合法的檢視、複製、播放、分享、匯出或處理權限。</p>
<p>3. 您不得利用本應用程式侵犯他人隱私權、肖像權、名譽權、智慧財產權、營業秘密或其他合法權益，不得利用本應用程式從事違法犯罪活動。</p>
<p>4. 您應當自行妥善保管自己的 iPhone、iPad、系統帳號、USB 裝置、轉接頭、本機錄影檔案和其他資料。</p>
<p class="subTitle">四、裝置資料夾授權與本機錄影管理</p>
<p>1. 本應用程式透過 iOS 系統檔案選擇器取得您主動選擇的資料夾存取授權。只有在您主動選擇並授權後，本應用程式才會讀取授權範圍內的檔案。</p>
<p>2. 您應當根據應用程式內說明，在系統檔案選擇器中選擇正確的 USB 裝置根目錄、錄影目錄或其他可識別目錄。若您選擇錯誤目錄，本應用程式可能無法掃描到錄影或無法正常顯示裝置內容。</p>
<p>3. 本應用程式可能在裝置本機儲存資料夾授權記錄、錄影索引、下載狀態、縮圖、本機儲存路徑等必要資訊，以便恢復授權狀態、顯示錄影清單、避免重複下載和支援本機播放。</p>
<p>4. 您下載到手機或平板本機的錄影由您自行管理。刪除本機錄影僅會刪除本應用程式本機儲存空間中的副本，不會刪除、移動、重新命名或修改 USB 裝置中的原始檔案。</p>
<p>5. 您在刪除本機錄影、清理快取、清除授權、解除安裝應用程式、系統還原、裝置更換或手動管理檔案前，應根據需要自行備份重要內容。</p>
<p class="subTitle">五、使用者行為規範</p>
<p>您在使用本應用程式時，不得實施以下行為：</p>
<p>1. 上傳、製作、複製、儲存、播放、分享、傳播任何違反法律法規、公序良俗或侵犯他人合法權益的內容。</p>
<p>2. 未經他人同意處理包含他人隱私、肖像、聲音、通訊內容、個人資料或其他敏感內容的錄影或檔案。</p>
<p>3. 利用本應用程式規避系統權限、安全機制、存取控制或第三方平台規則。</p>
<p>4. 對本應用程式進行反向工程、反向編譯、反組譯、破解、篡改、繞過授權、植入惡意程式碼或進行其他破壞應用程式正常運作的行為，但法律法規明確允許的除外。</p>
<p>5. 利用本應用程式或相關服務進行攻擊、掃描、干擾、破壞、過載、爬取、批量測試或其他影響我們、使用者、第三方系統安全和穩定的行為。</p>
<p>6. 冒用他人身分、虛構事實、惡意投訴、惡意回饋，或以其他方式損害我們、其他使用者或第三方合法權益。</p>
<p>如您違反本協議或法律法規，我們有權根據違法違規程度依法採取提醒、限制相關功能、停止提供服務、儲存必要記錄、向主管機關報告等措施。因您的行為造成我們、其他使用者或第三方損失的，您應依法承擔相應責任。</p>
<p class="subTitle">六、內容權利與授權</p>
<p>1. 您透過本應用程式讀取、下載、播放、分享或匯出的錄影、圖片、檔案等內容，其權利歸屬不因您使用本應用程式而發生轉移。</p>
<p>2. 對於您依法享有權利的內容，您仍保留相應權利；您應確保相關內容的使用不侵犯任何第三方合法權益。</p>
<p>3. 除為實現本應用程式本機播放、下載、縮圖生成、分享、匯出、故障排除等功能所必需的處理外，我們不會主動取得您錄影內容的所有權或其他不必要的權利。</p>
<p>4. 如您透過電子郵件或其他方式向我們提交問題回饋、截圖、日誌、錄影片段或其他材料，您同意我們在處理回饋、定位問題、改進產品和履行法定義務所必需的範圍內使用相關材料。</p>
<p class="subTitle">七、智慧財產權</p>
<p>1. 本應用程式及其相關軟體、介面設計、互動設計、圖示、文字、商標、標識、技術文件、程式碼、演算法、資料結構等內容，除依法屬於第三方或使用者自行提供的內容外，其智慧財產權及相關權益歸我們或合法權利人所有。</p>
<p>2. 未經我們或相關權利人事先書面許可，您不得複製、修改、改編、翻譯、發行、出租、展示、傳播、轉讓、授權、出售本應用程式或其組成部分，不得移除、遮蔽或修改本應用程式中的權利聲明、商標或標識。</p>
<p>3. 本協議未明示授權給您的權利，均由我們或相關權利人保留。</p>
<p class="subTitle">八、隱私與個人資料保護</p>
<p>1. 我們會按照《DV Link 隱私權政策》處理您的個人資料和相關資料。</p>
<p>2. 本應用程式目前版本不提供帳號註冊、登入功能，暫不接入第三方 SDK，不進行廣告投放、跨應用程式追蹤或第三方廣告歸因。</p>
<p>3. 為保障應用程式穩定運作、排除崩潰問題、最佳化掃描、下載和播放體驗，本應用程式可能會在依法取得必要授權或同意後，透過我們自有的日誌和分析能力收集崩潰日誌、效能資料、裝置型號、系統版本、應用程式版本等運作診斷資訊。</p>
<p>4. 您可以按照《DV Link 隱私權政策》中的說明管理相簿、通知、資料夾存取等系統權限，並行使查詢、更正、刪除、撤回授權等個人資料相關權利。</p>
<p class="subTitle">九、第三方服務與系統能力</p>
<p>1. 本應用程式可能呼叫 iOS / iPadOS 系統檔案選擇器、系統分享、相簿、通知、本機儲存、媒體播放等系統能力。相關系統能力由 Apple 或作業系統提供，其可用性、顯示方式、權限彈窗和行為可能因系統版本、裝置型號或 Apple 政策變化而不同。</p>
<p>2. 當您主動使用系統分享、匯出功能，將錄影交由其他應用程式、聯絡人、平台或服務處理時，該第三方如何處理相關內容，適用該第三方自身的協議、隱私權政策和服務規則。</p>
<p>3. 我們建議您在分享、匯出或發送包含個人資料、他人影像、聲音、車牌、住址、營業秘密或其他敏感資訊的錄影前，審慎確認接收方和分享範圍。</p>
<p class="subTitle">十、服務變更、中斷與終止</p>
<p>1. 我們可能根據產品規劃、技術升級、系統適配、法律法規、平台規則或安全需要，對本應用程式功能、介面、服務規則進行調整。</p>
<p>2. 因系統維護、版本更新、網路故障、裝置故障、第三方系統變更、不可抗力、法律法規或主管機關要求等原因，本應用程式部分功能可能發生中斷、延遲、異常或無法使用。</p>
<p>3. 如我們停止提供本應用程式或其中部分功能，我們將依法透過應用程式內提示、更新說明、公告或其他適當方式進行通知；法律法規另有規定的，從其規定。</p>
<p>4. 您可以隨時停止使用或解除安裝本應用程式。解除安裝本應用程式通常會刪除本應用程式沙盒內儲存的資料，但您已匯出、分享、儲存到相簿或儲存於其他位置的檔案可能不會隨應用程式解除安裝而刪除。</p>
<p class="subTitle">十一、風險提示與責任限制</p>
<p>1. 請您理解，本應用程式是基於 iOS / iPadOS 系統檔案存取機制提供的工具類應用程式。我們會盡合理努力保障本應用程式按說明提供功能，但不保證所有 USB 裝置、轉接頭、檔案系統、目錄結構、錄影格式或系統版本均可相容。</p>
<p>2. 因您選擇錯誤目錄、拔出裝置、裝置斷電、儲存空間不足、USB 裝置故障、轉接頭故障、系統權限變化、檔案損壞、第三方應用程式處理、您主動刪除或分享檔案等非我們原因導致的檔案無法存取、下載失敗、播放失敗、資料遺失、內容洩露或其他損失，由您自行承擔相應後果。</p>
<p>3. 對於本應用程式明確提示為「刪除本機錄影」「清除授權」「清理快取」等操作，請您在操作前仔細確認。相關操作完成後，可能無法在本應用程式內恢復。</p>
<p>4. 本協議中的責任限制不適用於因我們故意或重大過失造成您人身損害，或因我們故意或重大過失造成您財產損失的情形；法律法規另有強制規定的，從其規定。</p>
<p>5. 在法律法規允許的範圍內，我們對您因使用或無法使用本應用程式所產生的間接損失、可得利益損失、商譽損失、資料恢復成本、第三方索賠等不承擔超出法律規定範圍的責任，但因我們依法應承擔責任的情形除外。</p>
<p class="subTitle">十二、費用與付款</p>
<p>1. 本應用程式目前版本未提供應用程式內付費訂閱、會員服務或雲端加值服務。</p>
<p>2. 您下載、安裝或使用本應用程式過程中，可能由網路電信業者、裝置廠商、Apple 或其他第三方收取網路流量、裝置、系統、儲存或其他費用，該等費用由相關第三方按其規則收取。</p>
<p>3. 如後續本應用程式提供付費功能、訂閱、會員或其他加值服務，我們會在購買前向您明示服務內容、價格、計費週期、自動續費、取消方式和退款規則，並遵守 Apple App Store 及相關法律法規要求。</p>
<p class="subTitle">十三、未成年人保護</p>
<p>1. 本應用程式並非專門面向不滿十四周歲的兒童設計。</p>
<p>2. 未成年人使用本應用程式前，應取得父母或其他監護人的同意，並在監護人的指導下使用。</p>
<p>3. 監護人應指導未成年人合法、審慎使用錄影、分享、匯出、相簿、通知等功能，避免處理或傳播侵犯他人權益、含有敏感資訊或不適宜未成年人接觸的內容。</p>
<p class="subTitle">十四、協議變更</p>
<p>1. 我們可能根據產品功能、法律法規、平台規則或營運需要更新本協議。</p>
<p>2. 本協議更新後，我們會透過應用程式內提示、更新說明、公告或其他適當方式向您提示，並標明更新日期。</p>
<p>3. 如更新內容涉及您重大權益，我們會以適當方式進行顯著提示；依法需要取得您同意的，我們會在取得您的同意後再提供相應服務。</p>
<p>4. 若您不同意更新後的協議，您可以停止使用本應用程式；您在協議更新後繼續使用本應用程式的，視為您已接受更新後的協議，但法律法規另有規定的除外。</p>
<p class="subTitle">十五、法律適用與爭議解決</p>
<p>1. 本協議的訂立、生效、履行、解釋和爭議解決，適用中華人民共和國大陸地區法律；法律衝突規範不適用。</p>
<p>2. 因本協議或您使用本應用程式產生的爭議，雙方應先友好協商解決。</p>
<p>3. 協商不成的，任何一方均可依法向有管轄權的人民法院提起訴訟。</p>
<p class="subTitle">十六、聯絡我們</p>
<p>服務提供者：廣州錢櫃物聯科技有限公司</p>
<p>聯絡地址：廣州市南沙區南沙街道華匯國際廣場916</p>
<p>聯絡電話：020 34974033</p>
<p>支援信箱：naxclow@163.com</p>
<p>如您對本協議或本應用程式服務有任何疑問、意見、投訴或建議，可以透過以上聯絡方式聯絡我們。我們會在收到您的請求並核驗必要資訊後，依法在合理期限內處理和回覆。</p>
`

export default json
